// extracted by mini-css-extract-plugin
export default {"gamesRow":"GamesRow__gamesRow--2nK"};